import { useState, useEffect, useContext } from "react";
import { Modal } from "antd";
import { numericValueFormatter } from "@ts/utils";
import { createDatasource } from "@ts/retrieve-data";
import { mainContext } from "@ts/constants";
import moment from "moment";
import DatePicker from "@drop-downs/DatePicker";
import * as Sentry from "@sentry/react";
import $ from "jquery";
import { ColDef, GridApi } from "ag-grid-community";
import { IChannel, IMainContext, Rule } from "@ts/common-types";
import { useSelector } from "react-redux";
import AgGridModalLayout from "@components/wrappers/layouts/AgGridModalLayout";
import { AiOutlineClose } from "react-icons/ai";

const RulesSummaryModal = () => {
    const {
        rulesSummaryDisp,
        setRulesSummaryDisp,
        ruleLogsDate,
        setRuleLogsDate,
    } = useContext<IMainContext>(mainContext);
    const [rowData, setRowData] = useState<Rule[]>();
    const channel = useSelector((state: IChannel) => state.channel.value);
    const [rulesSummaryGridApi, setRulesSummaryGridApi] = useState<GridApi>();
    const [columnDefs] = useState<ColDef[]>([
        {
            field: "rule_id",
            headerName: "Rule_Id",
            filter: "agTextColumnFilter",
            minWidth: 100,
            maxWidth: 120
        },
        {
            field: "rule_name",
            headerName: " Rule",
            filter: "agTextColumnFilter",
            minWidth: 200,
        },
        {
            field: "no_of_changes",
            headerName: "No. of changes",
            filter: false,
            valueFormatter: numericValueFormatter,
            sort: "desc",
            cellRendererParams: {
                hasPinnedColumnValue: false,
            },
        },
    ]);
    const [loading, setLoading] = useState<boolean>(false);

    const handleClose = () => {
        setRowData([]);
        setRulesSummaryDisp(false);
        setRuleLogsDate(null);
    };

    function getChangeLogsDateObj() {
        const defaultLogsDate = {
            startDate: moment().subtract(7, "days"),
            endDate: moment().subtract(1, "days"),
        };
        const selectedDate = ruleLogsDate ? ruleLogsDate : defaultLogsDate;

        $("#logs-range span").html(
            moment(selectedDate.startDate).format("DD-MMM-YY") +
            " - " +
            moment(selectedDate.endDate).format("DD-MMM-YY")
        );

        return {
            start: moment(selectedDate.startDate).format("YYYY-MM-DD"),
            end: moment(selectedDate.endDate).format("YYYY-MM-DD"),
        };
    }

    const dateObj = getChangeLogsDateObj();

    const populateChangeLogsModal = async () => {
        const data = await createDatasource("change-logs", {
            dateObj,
        });
        return data;
    };

    useEffect(() => {
        if (rulesSummaryDisp) {
            setRowData([]);
            setLoading(true);
            populateChangeLogsModal()
                .then((logs) => {
                    setRowData(logs as Array<Rule>);
                    setLoading(false);
                })
                .catch((err) => {
                    console.error(err);
                    Sentry.captureException(err);
                });
        }
        // eslint-disable-next-line
    }, [rulesSummaryDisp, ruleLogsDate, channel]);

    return (
        <>
            <Modal
                title={<div className="d-flex align-items-center pb-3">
                    <h4>Rules Summary</h4>
                    <div
                        id="logs-range"
                    style={{ position: "absolute", right: "3rem" }}
                    ><DatePicker /></div>
                </div>
                }
                closeIcon={<AiOutlineClose style={{fontSize: "40px"}}/>}
                width={"55%"}
                open={rulesSummaryDisp} onCancel={handleClose}
                centered
                footer={[
                    <button
                        className="btn btn-secondary"
                        data-bs-dismiss="modal"
                        onClick={handleClose}
                    >
                        Close
                    </button>
                ]}>
                <div className="wrapper">
                    <div
                        id="rules-change-logs-grid"
                        className="ag-theme-alpine modal-box-content modal-box"
                        style={{ height: "25rem" }}
                    >
                        <AgGridModalLayout
                            rowData={rowData}
                            columnDefs={columnDefs}
                            isTotalRowsReq={false}
                            loading={loading}
                            api={rulesSummaryGridApi}
                            setGridApi={setRulesSummaryGridApi}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default RulesSummaryModal;
